import React from 'react'
import PropTypes from 'prop-types'
import {Image} from '@salesforce/retail-react-app/app/components/shared/ui'

/**
 * Helper to render a CMS-driven icon with a local SVG fallback.
 *
 * Priority for the image URL:
 *   1. `iconUrl` prop (from new GDIGlobalComponentsPage Icons field)
 *   2. `iconData.icon.url` (from legacy iconNavigation structure)
 */
const CmsIcon = ({iconUrl: iconUrlProp, iconData, FallbackIcon, iconStyles, fallbackProps, colorFilter}) => {
    const resolvedUrl = iconUrlProp || iconData?.icon?.url
    return resolvedUrl ? (
        <Image src={resolvedUrl} alt="" {...iconStyles} style={colorFilter} />
    ) : (
        <FallbackIcon {...fallbackProps} />
    )
}

CmsIcon.propTypes = {
    iconUrl: PropTypes.string,
    iconData: PropTypes.object,
    FallbackIcon: PropTypes.elementType.isRequired,
    iconStyles: PropTypes.object,
    fallbackProps: PropTypes.object,
    colorFilter: PropTypes.object
}

export default CmsIcon
